import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Organization } from '../models/organization.model';
import { User } from '../models/user.model';
import {ApiService} from './api.service';
import { CognitoUtil } from './cognito.service';

@Injectable()
export class OrganizationServices {

    baseURL = environment.organizationsLink;

    usersLink = environment.usersLink;

    notificationsLink = environment.activitiesLink;

    apiService: ApiService = new ApiService(this.http, this.cognito);

    constructor(
      private http: Http, private cognito: CognitoUtil
    ) { }

    getOrganizations(): Observable<Organization[]> {
        return this.http.get(this.baseURL + 'organizations')
            .map((data) => data.json())
            .catch(this.handleError);
    }

    getOrganizationList(){
        return this.http
            .get(this.baseURL + 'organizations/')
            .map((data) => data.json())
            .catch(this.handleError);
    }

    getOrganizationDetail(town: string) {
        return this.apiService.getCall('organizationsLink', `orgName/${town}`);
    }

    getOrganizationByID(orgId: string): Observable<Organization> {
        return this.apiService.getCall('organizationsLink', `/organizations/${orgId}`);
    }

    // POST : Create a New Organization
    createOrganization(org: Organization): Observable<Organization> {
      return this.apiService.postCall('organizationsLink',`organizations/`, org);
    }

    // PUT : Update an Organization
    updateOrganization(org: Organization): Observable<Organization> {
        return this.apiService.putCall('organizationsLink', `/organizations/${org.id}`, org);
    }

     // DELETE : Delete an Organization
     deleteOrganization(organizationID: string) {
         return this.apiService.deleteCall('organizationsLink', `/organizations/${organizationID}`);
    }

    // GET : All Users In An Organization
    getUsersInOrganization(orgID: string) {
      return this.apiService.getCall('usersLink', `organizations/${orgID}/users`);
    }

    getRecentActivity(orgId: string){
        return this.apiService.getCall('activitiesLink', `organizations/${orgId}/activities`);
    }

    // POST : Create a New user
    createUserInOrganization(user: User, orgID: string) {
        return this.apiService.postCall('usersLink', `organizations/${orgID}/users`, user);
    }

    private handleError(error: any) {
        return Observable.throw(error.json().error || 'Server error');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/organization.services.ts